<template>
  <div class="container">
    <div class="g-p-30"
         style="min-height: 550px"
         v-loading="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.5)">
      <el-tabs v-model="tabNow">
        <el-tab-pane label="我的课程" name="0"></el-tab-pane>
      </el-tabs>
      <!--  列表  -->
      <div class="course-item g-m-t-20" v-for="(item,index) in dataList" :key="index">
        <div class="g-p-15 g-flex g-row-between">
          <div class="g-flex">
            <img :src="item.cover" class="course-img" alt="">
            <div class="g-m-l-20">
              <p class="g-font-16 g-font-weight-5">{{ item.name }}</p>
              <p class="g-m-t-10 remark-text g-font-12">{{ item.chapterSectionInfo }}</p>
              <div class="g-flex g-m-t-10">
                <div class="g-flex">
                  <div class="item-tag g-m-r-15" v-if="item.isGood">
                    精品课程
                  </div>
                  <div class="item-tag g-m-r-15" v-if="item.classifyLevelOne">
                    {{ item.classifyLevelOne }}
                  </div>
                  <div class="item-tag g-m-r-15" v-if="item.classifyLevelTwo">
                    {{ item.classifyLevelTwo }}
                  </div>
                </div>
                <div class="g-m-l-5 remark-text">
                  {{ item.createTime }}
                </div>
              </div>
            </div>
          </div>
          <div class="g-text-right">
            <p class="blue-text g-text-right g-font-12">学习进度（{{ item.mediaProgress + '%' }}）</p>
            <div class="progress-box g-rela g-m-t-5">
              <div class="progress-item g-abso" :style="{width:item.mediaProgress+'px'}"></div>
            </div>
            <div class="g-flex g-m-t-24">
              <div class="submit-btn" v-if="!item.isExam &&item.mediaProgress === 100 && item.isTestPaper" @click="$router.push({
        name:'examination-detail',
        query: {
          id:item.paperId
        }
      })">去考试
              </div>
              <div class="submit-btn" @click="goPage('/course-detail/'+item.id)">去学习</div>
            </div>
          </div>
        </div>
      </div>
      <!--  分页  -->
      <div class="g-flex g-row-center g-m-t-30">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-sizes="[10,25,50]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getMyList} from '@/api/education/course'

export default {
  name: "my-course",
  data() {
    return {
      tabNow: '0',
      dataList: [],
      page: {
        current: 1,
        size: 10,
      },
      total: 0,
      loading: true
    }
  },
  created() {
    this.queryPagelist()
  },
  methods: {
    queryPagelist() {
      this.loading = true
      this.dataList = []
      getMyList(this.page).then(res => {
        this.loading = false
        this.dataList = res.records
        this.total = res.total
      }, error => {
        console.error(error)
        this.loading = false

      })
    },
    // 跳转
    goPage(url) {
      this.$router.push(url)
    },
    // 页数切换
    handleSizeChange(val) {
      this.page.size = val
      this.queryPagelist()
    },
    // 当前页切换
    handleCurrentChange(val) {
      this.page.current = val
      this.queryPagelist()
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  background: #fff;
  border-radius: 5px;
}

::v-deep .el-tabs__item.is-active {
  color: #333;
  font-size: 20px;
  font-weight: 500;
}

.course-item {
  background: #f6f6f8;
  border-radius: 5px;

  .course-img {
    width: 115px;
    height: 107px;
    border-radius: 5px;
  }

  .item-tag {
    background: #ffffff;
    border-radius: 20px;
    padding: 3px 12px;
    font-size: 12px;
    color: #407aff;
  }

  .progress-box {
    width: 100px;
    height: 6px;
    background: #e9f2ff;
    border-radius: 4px;
    margin-left: auto;

    .progress-item {
      left: 0;
      top: 0;
      z-index: 99;
      height: 6px;
      background: linear-gradient(90deg, #0068ff 0%, #00ffd1 100%);
      border-radius: 4px;
    }
  }

  .submit-btn {
    padding: 5px 29px;
    border-radius: 5px;
  }
}


</style>
